export const NETWORKVPC = 'NETWORKVPC'
export default NETWORKVPC;